import { IDENTIFY_TYPES } from 'constants/id';

const CVNA_CHAT_UI = 'CvnaChatUi';
const CVNA_CHAT_UI_SCROLL_POS = 'CvnaChatUiScrollPos';
const CVNA_CHAT_UI_DEBUG_MODE = 'CvnaChatUiDebugMode';
const CVNA_PROPEL_CONVERSATION = 'CvnaPropelConversation';
const CVNA_PROPEL_CHAT_CONTEXT = 'CvnaPropelChatContext';
const CVNA_ID_TOKEN = 'CVIdToken';

const PARTNER_OBJECT = 'PartnerObject';

const GEOLOCATION = 'Geolocation';
const RATING_FOLLOW_UP_CHALLENGE = 'RatingContactFollowUpChallenge';
const CHAT_INITIALIZE_VIEW = 'CvnaInitialViewState';
const CHAT_HANDRAISERS = 'CvnaChatHandraisers';

const LOCAL_STORAGE = 'local';
const SESSION_STORAGE = 'session';

export const LOCAL_STORAGE_KEY = {
  CVNA_CHAT_UI,
  CVNA_CHAT_UI_SCROLL_POS,
  CVNA_CHAT_UI_DEBUG_MODE,
  CVNA_PROPEL_CONVERSATION,
  CVNA_PROPEL_CHAT_CONTEXT,
  GEOLOCATION,
  RATING_FOLLOW_UP_CHALLENGE,
  /**
   * Used to keep the state of Chat across browser page loads.
   */
  CHAT_INITIALIZE_VIEW,
  CHAT_HANDRAISERS,
} as const;

export const SESSION_STORAGE_KEY = {
  /**
   * Used to keep the state of Chat across browser page loads.
   */
  CHAT_INITIALIZE_VIEW,
} as const;

export const STORAGE_LOCATION = {
  LOCAL_STORAGE,
  SESSION_STORAGE,
} as const;

export const COOKIE_KEY = {
  BROWSER_COOKIE_ID: IDENTIFY_TYPES.BROWSER_COOKIE_ID,
  PARTNER_OBJECT,
  CVNA_ID_TOKEN,
} as const;
